import { isHybridAnnualPowerEvent } from '../../../../../utils/events';
import { utrTypeIds } from '../../../../../utils/eventConstants';
import { nonPoweredPlayerDefaultDivisionFee } from '../../../../../utils/constants';

export function shouldShowSanctionedVerificationUpgrade({ event, userIsPowered }) {
    const eventVerificationFeeParsed = parseFloat(event.verificationFee) || 0;
    const clubVerificationFee = eventVerificationFeeParsed >= 0 ? eventVerificationFeeParsed : nonPoweredPlayerDefaultDivisionFee;
    const isSanctioned = event.utrType?.value === 'sanctioned' || event.utrTypeId === utrTypeIds.SANCTIONED;
    return !userIsPowered && isSanctioned && event?.workflowVersion > 1 && clubVerificationFee > 0 && !isHybridAnnualPowerEvent(event);
}
